import BasicContentAccordion from './BasicContentAccordion';

export { type BasicContentAccordionProps } from './BasicContentAccordion';
export default BasicContentAccordion;
